import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import {
  Form,
  Divider,
  Tabs,
  Spin,
  List,
  Input,
  Select,
  Button,
  Modal,
  Icon
} from "antd";
import UpdateApplicantAppointmentForm, {
  UpdateApplicantAppointmentFormProps
} from "./UpdateApplicantAppointmentForm";
import { IRegisteredApplicantDetailsPresenter } from "../../../presenter/applicants/RegisteredApplicantDetailsPresenter";
import ApplicantDetailsOverview from "./details/ApplicantDetailsOverview";
import Title from "antd/lib/typography/Title";
import ApplicantReportingPeriodGrid from "./details/ApplicantReportingPeriodGrid";
import ReportingPeriodPermissionsGrid from "./details/permissions/ReportingPeriodPermissionsGrid";
import ApplicantEvaluationsGrid from "./details/ApplicantEvaluationsGrid";
import TickBox from "../../components/app/grid/TickBox";
import ApplicantFormsGrid from "./details/ApplicantFormsGrid";
import Loader from "../../components/Loader";
import Text from "antd/lib/typography/Text";
import {
  AdditionalCheckForAnnouncement,
  ModalConstants,
  FormalCheckStatus,
  FormTypesStatuses,
  RoleConstants
} from "../../../common/Constants";
import Dialog from "../../components/app/Dialog";
import { ApplicationService } from "../../../service/ApplicationService";
import ApplicantDocumentsGrid from "../../components/applicants/details/ApplicantDocumentsGrid";
import { IValueListItem } from "../../../model/valuelist/ValueListItem";
import CreateApplicantAppointmentForm, {
  CreateApplicantAppointmentFormProps
} from "./CreateApplicantAppointmentForm";

const { TabPane } = Tabs;

export interface Props extends PageProps {}
export interface State extends IRegisteredApplicantDetailsPresenter {}

export default class RegisteredApplicantDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      applicantsAppointments = [],
      positionTypes,
      updateApplicantsAppointment,
      requests,
      onChangeTab,
      applicant,
      applicantReportingPeriodPermissions,
      reportingPeriods,
      onRowExpanded,
      createRequest,
      updateRequest,
      requestTypes,
      formTypes,
      formVersions,
      onExpandReportingPeriod,
      onExpandFormType,
      onEvaluationsTabFormTypeExpanded,
      onDocumentsReportingPeriodExpanded,
      formVersionDocumentsPresenter,
      modalVisible,
      onChangeModalVisible,
      onChangeFormVersionDetails,
      formVersionDetails,
      markForAdditionalCheck,
      updateStatusOfAdditionalCheck,
      setFormVersionFormAnnouncement,
      updateElectronicRegistryNumber,
      currentItem,
      onEvaluationsTabFormVersionExpanded,
      formVersionEvaluationsPresenter,
      addNewDraftFormVersion,
      expandedReportingPeriod,
      updateStatusOfFormalCheck,
      hasForms,
      defaultTab,
      updateAdditionalEvalutionResult,
      getAdditionalEvaluationResult,
      additionalCheckStatusList,
      expandedFormType,
      configuration,
      createApplicantsAppointment,
      roles = []
    } = this.state as any;

    const dialogOkText = translate("modal_functions.action_modal.accept");
    const dialogCancelText = translate("modal_functions.action_modal.cancel");

    const UpdateForm = Form.create<UpdateApplicantAppointmentFormProps>({})(
      UpdateApplicantAppointmentForm
    );

    const CreateForm = Form.create<CreateApplicantAppointmentFormProps>({})(
      CreateApplicantAppointmentForm
    );

    const renderAdditionalCheck = hasForms ? (
      <Input.TextArea
        value={formVersionDetails.reasonAdditionalCheck}
        onChange={(e) =>
          onChangeFormVersionDetails(
            "reasonAdditionalCheck",
            e.currentTarget.value
          )
        }
        placeholder={translate("applicantForms_page.optionally")}
        allowClear={true}
        autoSize={{ minRows: 3 }}
      />
    ) : (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <Icon
          type="warning"
          theme="filled"
          style={{ fontSize: 40, marginRight: 10, color: "#FAAD14" }}
        />
        <Text>
          {translate("applicantForms_page.for_announcement_warning_msg")}
        </Text>
      </div>
    );

    const renderAdditionalCheckStatus = hasForms ? (
      <Select
        value={formVersionDetails.statusAdditionalCheck}
        placeholder={translate(
          "applicantForms_page.additional_check.select_status"
        )}
        style={{ width: "100%" }}
        allowClear
        onChange={(e) => onChangeFormVersionDetails("statusAdditionalCheck", e)}
        notFoundContent={translate("search.no_data")}
      >
        {(additionalCheckStatusList || []).map((item: IValueListItem) => (
          <Select.Option key={item.code}>{item.value}</Select.Option>
        ))}
      </Select>
    ) : (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }}
      >
        <Icon
          type="warning"
          theme="filled"
          style={{ fontSize: 40, marginRight: 10, color: "#FAAD14" }}
        />
        <Text>
          {translate("applicantForms_page.for_announcement_warning_msg")}
        </Text>
      </div>
    );

    const announcementWarningKey =
      currentItem?.formalCheckStatus !== true
        ? "applicantForms_page.for_announcement_warning_msg"
        : "applicantForms_page.for_announcement_not_signed_warning_msg";

    const renderForAnnouncement =
      formVersionDetails.isAnnouncementVisible === false ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          }}
        >
          <Icon
            type="warning"
            theme="filled"
            style={{ fontSize: 40, marginRight: 10, color: "#FAAD14" }}
          />
          <Text>{translate(announcementWarningKey)}</Text>
        </div>
      ) : (
        <Select
          value={formVersionDetails.forAnnouncement}
          placeholder={translate("applicantForms_page.for_announcement")}
          style={{ width: "100%" }}
          allowClear
          onChange={(e) => onChangeFormVersionDetails("forAnnouncement", e)}
          notFoundContent={translate("search.no_data")}
          disabled={!formVersionDetails.isAnnouncementVisible}
        >
          <Select.Option key={AdditionalCheckForAnnouncement.YES}>
            {translate("applicantForms_page.announcement_status.yes")}
          </Select.Option>
          <Select.Option key={AdditionalCheckForAnnouncement.NO}>
            {translate("applicantForms_page.announcement_status.no")}
          </Select.Option>
        </Select>
      );

    const renderNumberElectronicRegistry = (
      <div>
        <Input
          addonBefore={
            <Text style={{ paddingRight: 22 }}>
              {translate("applicantForms_page.number_er")}
            </Text>
          }
          value={formVersionDetails.numberItemElectronicRegistry}
          onChange={(e) =>
            onChangeFormVersionDetails(
              "numberItemElectronicRegistry",
              e.currentTarget.value
            )
          }
          placeholder={translate("applicantForms_page.optionally")}
          allowClear={true}
        />
        <Input
          addonBefore={translate("applicantForms_page.subnumber_er")}
          value={formVersionDetails.subNumberItemElectronicRegistry}
          onChange={(e) =>
            onChangeFormVersionDetails(
              "subNumberItemElectronicRegistry",
              e.currentTarget.value
            )
          }
          placeholder={translate("applicantForms_page.optionally")}
          allowClear={true}
          style={{ marginTop: 10 }}
        />
      </div>
    );

    const renderFormalCheck = (
      <Select
        value={formVersionDetails.formalCheckStatus}
        placeholder={translate(
          "applicantForms_page.formal_check.select_status"
        )}
        style={{ width: "100%" }}
        onChange={(e) => onChangeFormVersionDetails("formalCheckStatus", e)}
        notFoundContent={translate("search.no_data")}
      >
        <Select.Option key={FormalCheckStatus.ACCEPT}>
          {translate(
            `applicantForms_page.formal_check.${FormalCheckStatus.ACCEPT}`
          )}
        </Select.Option>
        <Select.Option key={FormalCheckStatus.REJECT}>
          {translate(
            `applicantForms_page.formal_check.${FormalCheckStatus.REJECT}`
          )}
        </Select.Option>
      </Select>
    );

    const applicantAppointmentColumns = [
      {
        title: translate("applicant_appointment.source_data"),
        dataIndex: "sourceData",
        key: "sourceData"
      },
      {
        title: translate("applicant_appointment.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("applicant_appointment.appointment_date"),
        dataIndex: "appointmentDate",
        key: "appointmentDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.appointmentDate,
            b.appointmentDate
          )
      },
      {
        title: translate("applicant_appointment.start_mandate"),
        dataIndex: "startMandate",
        key: "startMandate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.startMandate, b.startMandate)
      },
      {
        title: translate("applicant_appointment.predicted_end"),
        dataIndex: "predictedEnd",
        key: "predictedEnd",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.predictedEnd, b.predictedEnd)
      },
      {
        title: translate("applicant_appointment.end_mandate"),
        dataIndex: "endMandate",
        key: "endMandate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.endMandate, b.endMandate)
      },
      {
        title: translate("applicant_appointment.mandate_end_reason"),
        dataIndex: "mandateEndReason",
        key: "mandateEndReason"
      },
      {
        title: translate("applicant_appointment.position_type_name"),
        dataIndex: "positionTypeName",
        key: "positionTypeName"
      },
      {
        title: translate("applicant_appointment.institution_name"),
        dataIndex: "institutionName",
        key: "institutionName"
      },
      {
        title: translate("applicant_appointment.appointment_valid"),
        dataIndex: "appointmentValid",
        key: "appointmentValid",
        render: (text, record) => <TickBox value={record.appointmentValid} />,
        width: "5%",
        align: "center"
      }
    ];

    const registeredApplicantDetails = (
      <div>
        <ApplicantDetailsOverview applicant={applicant} translate={translate} />
        <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
        <Tabs
          defaultActiveKey={defaultTab}
          onChange={onChangeTab}
          animated={false}
        >
          {ApplicationService().hasAnyRole(
            [RoleConstants.MIK_BO.MIK_ADMIN, RoleConstants.MIK_BO.MIK_OSOBLJE],
            roles
          ) && (
            <TabPane
              tab={translate("applicant_appointment.appointment_details")}
              key="appointment"
            >
              <Spin
                spinning={
                  this.state.loaders.appointmentsLoader ||
                  this.state.loaders.initialDataLoader ||
                  false
                }
              >
                <DataGrid
                  title={translate("grids.applicant-appointments")}
                  translate={translate}
                  columns={applicantAppointmentColumns}
                  dataSource={applicantsAppointments}
                  allowCreate={true}
                  createForm={CreateForm}
                  createModalTitle={translate(
                    "applicant_appointment.create_modal_title"
                  )}
                  addButtonText={translate(
                    "applicant_appointment.add_button_text"
                  )}
                  onCreate={createApplicantsAppointment}
                  allowUpdate={true}
                  updateForm={UpdateForm}
                  updateModalTitle={translate(
                    "applicant_appointment.insert_modal_title"
                  )}
                  onUpdate={updateApplicantsAppointment}
                  codebooks={positionTypes}
                  booleanColumnKeys={["appointmentValid"]}
                />
              </Spin>
            </TabPane>
          )}
          {ApplicationService().hasAnyRole(
            [
              RoleConstants.MIK_BO.MIK_ADMIN,
              RoleConstants.MIK_BO.MIK_OSOBLJE,
              RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
            ],
            roles
          ) && (
            <TabPane tab="Obrasci" key="form">
              <Spin
                spinning={
                  this.state.loaders.formLoader ||
                  this.state.loaders.initialDataLoader ||
                  false
                }
              >
                <ApplicantFormsGrid
                  reportingPeriods={reportingPeriods}
                  formTypes={formTypes}
                  formVersions={formVersions}
                  translate={translate}
                  onExpandReportingPeriod={onExpandReportingPeriod}
                  onExpandFormType={onExpandFormType}
                  formTypesLoader={this.state.loaders.boFormTypesLoader}
                  formVersionsLoader={this.state.loaders.boFormVersionsLoader}
                  onChangeModalVisible={onChangeModalVisible}
                  applicant={applicant}
                  addNewDraftFormVersion={addNewDraftFormVersion}
                  updateAdditionalEvalutionResult={
                    updateAdditionalEvalutionResult
                  }
                  getAdditionalEvaluationResult={getAdditionalEvaluationResult}
                  configuration={configuration}
                />
              </Spin>
            </TabPane>
          )}
          {ApplicationService().hasAnyRole(
            [RoleConstants.MIK_BO.MIK_ADMIN, RoleConstants.MIK_BO.MIK_OSOBLJE],
            roles
          ) && (
            <TabPane
              tab={translate("form_version_document_form.title")}
              key="documents"
            >
              <Spin
                spinning={
                  this.state.loaders.documentsLoader ||
                  this.state.loaders.initialDataLoader ||
                  false
                }
              >
                <ApplicantDocumentsGrid
                  reportingPeriods={reportingPeriods}
                  translate={translate}
                  onExpandReportingPeriod={onDocumentsReportingPeriodExpanded}
                  formTypesLoader={this.state.loaders.boFormTypesLoader}
                  formVersionDocumentsPresenter={formVersionDocumentsPresenter}
                />
              </Spin>
            </TabPane>
          )}
          {ApplicationService().hasAnyRole(
            [
              RoleConstants.MIK_BO.MIK_ADMIN,
              RoleConstants.MIK_BO.MIK_OSOBLJE,
              RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
            ],
            roles
          ) && (
            <TabPane tab="Prava pristupa" key="permissions">
              <Title level={4} style={{ fontSize: 18 }}>
                {translate("reporting_period_permission_page.permissions")}
              </Title>
              <Spin
                spinning={
                  this.state.loaders.permissionsLoader ||
                  this.state.loaders.initialDataLoader ||
                  false
                }
              >
                {applicantReportingPeriodPermissions.map((item, index) => {
                  return (
                    <div key={index}>
                      <ReportingPeriodPermissionsGrid
                        title={
                          <List.Item>
                            <List.Item.Meta
                              title={`${item.reportingPeriod.reportingTypeName} - ${item.reportingPeriod.reportingPeriodName}`}
                              description={
                                item.reportingPeriod.fromPeriod ||
                                item.reportingPeriod.toPeriod
                                  ? `${item.reportingPeriod.fromPeriod || ""} - ${
                                      item.reportingPeriod.toPeriod || ""
                                    }`
                                  : null
                              }
                            />
                          </List.Item>
                        }
                        {...item.model}
                        key={`permission-period-${index.toString()}`}
                      />
                      <Divider
                        type={"horizontal"}
                        style={{ marginTop: 8, marginBottom: 8 }}
                      />
                    </div>
                  );
                })}
              </Spin>
            </TabPane>
          )}
          {ApplicationService().hasAnyRole(
            [RoleConstants.MIK_BO.MIK_ADMIN, RoleConstants.MIK_BO.MIK_OSOBLJE],
            roles
          ) && (
            <TabPane tab="Provjere" key="evaluations">
              <Spin
                spinning={
                  this.state.loaders.evaluationsLoader ||
                  this.state.loaders.initialDataLoader ||
                  false
                }
              >
                <ApplicantEvaluationsGrid
                  reportingPeriods={reportingPeriods}
                  formTypes={formTypes}
                  formVersions={formVersions}
                  translate={translate}
                  onExpandReportingPeriod={onExpandReportingPeriod}
                  onExpandFormType={onEvaluationsTabFormTypeExpanded}
                  onExpandFormVersion={onEvaluationsTabFormVersionExpanded}
                  formTypesLoader={this.state.loaders.boFormTypesLoader}
                  formVersionsLoader={this.state.loaders.boFormVersionsLoader}
                  formVersionEvaluationsPresenter={
                    formVersionEvaluationsPresenter
                  }
                  onChangeModalVisible={onChangeModalVisible}
                  applicant={applicant}
                  addNewDraftFormVersion={addNewDraftFormVersion}
                  configuration={configuration}
                />
              </Spin>
            </TabPane>
          )}
          {ApplicationService().hasAnyRole(
            [RoleConstants.MIK_BO.MIK_ADMIN, RoleConstants.MIK_BO.MIK_OSOBLJE],
            roles
          ) && (
            <TabPane tab="Zahtjevi" key="requests">
              <Spin spinning={this.state.loaders.requestsLoader || false}>
                <ApplicantReportingPeriodGrid
                  translate={translate}
                  requests={requests}
                  reportingPeriods={reportingPeriods}
                  onRowExpanded={onRowExpanded}
                  requestTypes={requestTypes}
                  createRequest={createRequest}
                  updateRequest={updateRequest}
                  expandedReportingPeriod={expandedReportingPeriod}
                  loader={this.state.loaders.requestLoader}
                />
              </Spin>
            </TabPane>
          )}
        </Tabs>
      </div>
    );
    return (
      <Page {...this.props}>
        <Title level={4}>
          {`${applicant.name ? applicant.name + " - " : ""} ${translate(
            "registered_applicant_page.applicant_details"
          )}`}
        </Title>
        <Loader
          children={registeredApplicantDetails}
          translate={translate}
          loading={
            this.state.loaders.applicantLoader ||
            this.state.loaders.appointmentsLoader
          }
        />
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.additionalCheck}
          title={`${translate("applicantForms_page.reporting_period")}: ${
            (currentItem && currentItem.reportingPeriodName) || ""
          }`}
          subtitle={translate("applicantForms_page.additional_check.title")}
          onOk={markForAdditionalCheck}
          onCancel={() => onChangeModalVisible("additionalCheck", false)}
          children={renderAdditionalCheck}
          label={translate("applicantForms_page.additional_check.reason")}
          okButtonProps={{
            disabled: !hasForms
          }}
        />
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.statusAdditionalCheck}
          title={`${translate("applicantForms_page.reporting_period")}: ${
            (currentItem && currentItem.reportingPeriodName) || ""
          }`}
          subtitle={translate(
            "applicantForms_page.additional_check.status_title"
          )}
          onOk={updateStatusOfAdditionalCheck}
          onCancel={() => onChangeModalVisible("statusAdditionalCheck", false)}
          children={renderAdditionalCheckStatus}
          label={translate("applicantForms_page.additional_check.status")}
          okButtonProps={{
            disabled: !hasForms || !formVersionDetails.statusAdditionalCheck
          }}
        />
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.announcement}
          title={`${translate("applicantForms_page.version")}: ${
            (currentItem && currentItem.version) || ""
          }`}
          subtitle={translate("applicantForms_page.announcement_title")}
          onOk={() => {
            if (
              formVersionDetails.forAnnouncement ===
                AdditionalCheckForAnnouncement.YES &&
              expandedFormType?.formTypeStatus === FormTypesStatuses.OBSOLETE
            ) {
              onChangeModalVisible("obsoleteFormTypeAnnouncement", true);
            } else {
              setFormVersionFormAnnouncement();
            }
          }}
          okButtonProps={{
            disabled: !formVersionDetails.isAnnouncementVisible
          }}
          onCancel={() => onChangeModalVisible("announcement", false)}
          children={renderForAnnouncement}
          label={translate("applicantForms_page.for_announcement")}
        />
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.electronicRegistry}
          title={`${translate("applicantForms_page.version")}: ${
            (currentItem && currentItem.version) || ""
          }`}
          subtitle={translate("applicantForms_page.electronic_registry")}
          onOk={updateElectronicRegistryNumber}
          onCancel={() => onChangeModalVisible("electronicRegistry", false)}
          children={renderNumberElectronicRegistry}
        />

        <Modal
          visible={modalVisible.newEvaluation}
          title={translate(
            "applicantEvaluation_page.evaluation.report_validation"
          )}
          onCancel={() => onChangeModalVisible("newEvaluation", false)}
          maskClosable={false}
          footer={[
            <Button
              key="back"
              onClick={() => onChangeModalVisible("newEvaluation", false)}
            >
              {translate("modal_functions.action_modal.cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                formVersionEvaluationsPresenter?.executeReportValidation();
                onChangeModalVisible("newEvaluation", false);
              }}
            >
              {translate("modal_functions.action_modal.accept")}
            </Button>
          ]}
          width={ModalConstants.WIDTH}
        >
          {translate(
            "applicantEvaluation_page.evaluation.validate_report_confirmation_message"
          )}
        </Modal>
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.formalCheck}
          title={`${translate("applicantForms_page.version")}: ${
            (currentItem && currentItem.version) || ""
          }`}
          subtitle={translate("applicantForms_page.formal_check.title")}
          onOk={updateStatusOfFormalCheck}
          onCancel={() => onChangeModalVisible("formalCheck", false)}
          children={renderFormalCheck}
          label={translate("applicantForms_page.formal_check.status")}
        />
        <Dialog
          okText={dialogOkText}
          cancelText={dialogCancelText}
          modalVisible={modalVisible.obsoleteFormTypeAnnouncement}
          title={translate("applicantForms_page.obsolete_form_type")}
          children={
            <div>
              {translate("applicantForms_page.obsolete_form_type_dialog_msg")}
            </div>
          }
          onCancel={() => {
            onChangeModalVisible("obsoleteFormTypeAnnouncement", false);
            onChangeModalVisible("announcement", false);
          }}
          onOk={setFormVersionFormAnnouncement}
        />
      </Page>
    );
  }
}
